import './sass/index.sass';
import Helmet from 'react-helmet';
import React from 'react';
import favicon from '../../common/app/favicon';
import start from '../../common/app/start';
import {Match} from '../../common/app/components';
import {Miss} from 'react-router';
import {connect} from 'react-redux';
import Home from '../home/HomePage';
import NotFound from '../notfound/NotFoundPage';
import Login from '../login/Login';
import Browser from '../device/Browser';
import ChooseDomain from '../chooseDomain/ChooseDomain';
import PinLogin from '../login/PinLogin';
import PinSwitchLogin from '../login/PinSwitchLogin';
import ChooseOffer from '../login/ChooseOffer';
import OpenReport from '../report/OpenReport';
import CloseReport from '../report/CloseReport';
import ReportCashboxesCounter from '../report/ReportCashboxesCounter';
import Print from '../print/Print';
import KitchenPrint from '../print/KitchenPrint';
import ChooseBar from '../login/ChooseBar';
import FullLoading from '../components/loadings/FullLoading';
import ErrorMessage from '../components/messages/ErrorMessage';
import {setKitchenPrintDeviceSettings} from '../../common/categories/actions';
import {lockUser} from '../../common/users/actions';
import {getOrganizationName} from '../../common/device/actions';
import {addLog} from '../../common/logs/actions';
import {isEnv, validateBrowser} from '../../common/lib/util';
import Shapes from '../components/Shapes';
import MigrationTroubleShooter from '../login/MigrationTroubleShooter';

// v4-alpha.getbootstrap.com/getting-started/introduction/#starter-template
const bootstrap4Metas: any = [
    {charset: 'utf-8'},
    {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no',
    },
    {
        'http-equiv': 'x-ua-compatible',
        content: 'ie=edge',
    },
];

let lastTouch = 0;
class App extends React.Component {

    static propTypes = {
        currentLocale: React.PropTypes.string.isRequired,
        viewer: React.PropTypes.object,
        bar: React.PropTypes.object,
        branch: React.PropTypes.object,
        logTypes: React.PropTypes.object,
        deviceId: React.PropTypes.number,
        reportOpen: React.PropTypes.bool,
        fullLoadingShow: React.PropTypes.bool,
        locked: React.PropTypes.bool,
        openCloseReportPanel: React.PropTypes.bool,
        allowLoginByPin: React.PropTypes.bool,
        fullScreen: React.PropTypes.bool,
        loginByPin: React.PropTypes.bool,
        messageVisible: React.PropTypes.bool,
        kitchenPrint: React.PropTypes.bool,
        kitchenPrintType: React.PropTypes.string,
        kitchenPrintLength: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.number
        ]),
        kitchenPrintAddress: React.PropTypes.string,
        showReportCashboxesCounter: React.PropTypes.bool,
        offerId: React.PropTypes.number,
        logoutTimer: React.PropTypes.number,
        lockUser: React.PropTypes.func,
        setKitchenPrintDeviceSettings: React.PropTypes.func,
        getOrganizationName: React.PropTypes.func
    }

    constructor(props) {
        super(props);

        this.lockTimer = this.lockTimer.bind(this);
        this.setLastTouch = this.setLastTouch.bind(this);
    }

    setLastTouch() {
        lastTouch = Date.now();
    }

    componentWillReceiveProps(nextProps) {
        const {
            viewer: oldViewer, addLog, logTypes, setKitchenPrintDeviceSettings,
            kitchenPrint: kitchenPrintOld,
            kitchenPrintLength: kitchenPrintLengthOld,
            kitchenPrintType: kitchenPrintTypeOld,
            kitchenPrintAddress: kitchenPrintAddressOld
        } = this.props;
        const {
            viewer: newViewer,
            kitchenPrint: kitchenPrintNew,
            kitchenPrintLength: kitchenPrintLengthNew,
            kitchenPrintType: kitchenPrintTypeNew,
            kitchenPrintAddress: kitchenPrintAddressNew
        } = nextProps;
        if (!!oldViewer && !!newViewer
            && oldViewer.get('userId') !== null && newViewer.get('userId') !== null
            && typeof oldViewer.get('userId') !== 'undefined' && typeof newViewer.get('userId') !== 'undefined') {
            if (oldViewer.get('userId') !== newViewer.get('userId')) {
                addLog(logTypes.LOGIN_PIN_POS, newViewer.get('userId'));
            }
        }

        if (kitchenPrintOld !== kitchenPrintNew) {
            setKitchenPrintDeviceSettings('kitchenPrintDeviceSettings', kitchenPrintNew);
        }
        if (kitchenPrintTypeOld !== kitchenPrintTypeNew) {
            setKitchenPrintDeviceSettings('kitchenPrintType', kitchenPrintTypeNew);
        }
        if (kitchenPrintAddressOld !== kitchenPrintAddressNew) {
            setKitchenPrintDeviceSettings('kitchenPrintAddress', kitchenPrintAddressNew);
        }
        if (kitchenPrintLengthOld !== kitchenPrintLengthNew) {
            setKitchenPrintDeviceSettings('kitchenPrintLength', kitchenPrintLengthNew);
        }
    }

    componentWillMount() {
        const {getOrganizationName} = this.props;
        getOrganizationName();
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.setLastTouch);
        window.removeEventListener('mousemove', this.setLastTouch);
        window.removeEventListener('click', this.setLastTouch);
    }

    componentDidMount() {
        setInterval(this.lockTimer, 5000);

        window.addEventListener('keydown', this.setLastTouch);
        window.addEventListener('mousemove', this.setLastTouch);
        window.addEventListener('click', this.setLastTouch);

        if (isEnv(['android_app', 'electron'])) {
            if (typeof window.parent.Ocellot !== 'undefined') {
                window.parent.Ocellot.setOrigin(window.location.origin);
            } else {
                window.parent.ocellotSetOrigin(window.location.origin);
            }
        }
    }

    lockTimer() {
        const {logoutTimer, locked, viewer, lockUser, addLog, logTypes} = this.props;
        if (!!lastTouch && !!logoutTimer && !locked && !!viewer) {
            if (lastTouch > 0 && (lastTouch + logoutTimer) < Date.now()) {
                lockUser();
                addLog(logTypes.PIN_AUTO_LOCK, viewer.get('userId'));
            }
        }
    }

    render() {
        const {
            reportOpen, currentLocale, viewer, bar, fullLoadingShow, offerId, messageVisible, deviceId,
            openCloseReportPanel, showReportCashboxesCounter, loginByPin, allowLoginByPin, locked
        } = this.props;

        const showLoginByPin = loginByPin && allowLoginByPin;
        let showBrowsers = false;
        if (!viewer && typeof window !== 'undefined' && !isEnv(['android_app', 'electron']) && !validateBrowser()) {
            showBrowsers = true;
        }

        return (

            <div>
                <Helmet
                    title='Trisbee pokladna'
                    htmlAttributes={{lang: currentLocale}}
                    meta={[
                        ...bootstrap4Metas,
                        {
                            name: 'Trisbee pokladna',
                            content: 'Trisbee pokladna',
                        },
                        ...favicon.meta,
                    ]}
                    link={[
                        ...favicon.link,
                    ]}
                />

                <Shapes/>

                {locked &&
                <PinSwitchLogin/>
                }
                {fullLoadingShow &&
                <FullLoading />
                }
                {openCloseReportPanel &&
                <CloseReport />
                }

                {!!messageVisible &&
                <Match exactly pattern="/" component={ErrorMessage}/>
                }
                {showBrowsers &&
                <Match exactly pattern="/" component={Browser}/>
                }
                {!viewer && !showLoginByPin && !showBrowsers &&
                <Match exactly pattern="/" component={Login}/>
                }
                {!viewer && showLoginByPin && !showBrowsers &&
                <Match exactly pattern="/" component={PinLogin}/>
                }
                {!!viewer && !!deviceId && !bar &&
                <Match exactly pattern="/" component={ChooseBar}/>
                }
                {!!viewer && !!deviceId && !!bar && !reportOpen &&
                <Match exactly pattern="/" component={OpenReport}/>
                }
                {!!viewer && !!deviceId && !!bar && !!reportOpen && showReportCashboxesCounter &&
                <ReportCashboxesCounter />
                }
                {!!viewer && !!deviceId && !!bar && !!reportOpen && !offerId &&
                <Match exactly pattern="/" component={ChooseOffer}/>
                }
                {!!viewer && !!deviceId && !!bar && !!reportOpen && !!offerId &&
                <Match exactly pattern="/" component={Home}/>
                }

                <Match exactly pattern="/migration-troubleshooter" component={MigrationTroubleShooter}/>
                <Match exactly pattern="/choose-domain" component={ChooseDomain}/>
                <Match exactly pattern="/choose-domain/1" component={ChooseDomain}/>
                <Miss component={NotFound}/>
                <Print/>
                <KitchenPrint/>
            </div>
        );
    }
}

export default start(connect(state => ({
    currentLocale: state.intl.currentLocale,
    viewer: state.users.get('viewer'),
    showReportCashboxesCounter: state.barReportCashboxes.get('showReportCashboxesCounter'),
    bar: state.bars.get('bar'),
    branch: state.branches.get('branch'),
    offerId: state.categories.get('offerId'),
    messageVisible: state.messages.get('messageVisible'),
    deviceId: state.device.get('id'),
    fullLoadingShow: state.loadings.get('fullLoadingShow'),
    openCloseReportPanel: state.barReport.get('openCloseReportPanel'),
    reportOpen: state.barReport.get('reportOpen'),
    loginByPin: state.device.loginByPin,
    fullScreen: state.device.fullScreen,
    allowLoginByPin: state.users.allowLoginByPin,
    locked: state.users.locked,
    lastTouch: state.users.locked,
    logoutTimer: state.device.logoutTimer,
    kitchenPrint: state.device.kitchenPrint,
    kitchenPrintAddress: state.device.kitchenPrintAddress,
    kitchenPrintType: state.device.kitchenPrintType,
    kitchenPrintLength: state.device.kitchenPrintLength,
    logTypes: state.logs.logTypes
}), {lockUser, addLog, getOrganizationName, setKitchenPrintDeviceSettings})(App));



// WEBPACK FOOTER //
// ./src/browser/app/App.js